<template>
  <div>
    <tabs v-model="activeTab" @change="onChangeTab" color="#fc9153" title-active-color="#fc9153" swipeable sticky>
      <tab v-for="tabItem in tabList" :key="tabItem.list_type" :name="tabItem.list_type">
        <div slot="title">
          <div class="title-slot">
            <span>{{tabItem.name}}</span>
          </div>
        </div>
      </tab>
      <div class="content-list">
        <MovieItemFeed :listType="activeTab" :listStyle="listStyle(activeTab)"></MovieItemFeed>
      </div>
    </tabs>
  </div>
</template>

<script>

  import {Tab, Tabs} from "vant"

  import MixItemFeedGoods from "../ugc_item/MixItemFeedGoods";
  import MixItemFeed from "../ugc_item/MixItemFeed";
  import GeneralDisplayBox from "../ugc_item/GeneralDisplayBox";
  import GeneralDisplayBoxFeed from "../ugc_item/GeneralDisplayBoxFeed";
  import MovieItemFeed from "../ugc_item/MovieItemFeed";
  export default {
    name: "TabList",
    components: {MovieItemFeed, GeneralDisplayBoxFeed, GeneralDisplayBox, MixItemFeed, MixItemFeedGoods, Tabs, Tab},
    props: {
      dataList: {},
      initialActiveTab: {},
    },
    data() {
      return {
        activeTab: "",
        tabList: [],
        tabMap: {},
      }
    },

    mounted() {
      this.initTabList()
      if (this.initialActiveTab) {
        this.activeTab = this.initialActiveTab
      }
    },

    methods: {
      initTabList() {
        this.tabList = this.dataList
        for (let i = 0; i < this.tabList.length; i ++) {
          this.tabMap[this.tabList[i].list_type] = this.tabList[i]
        }
      },

      onChangeTab() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        let queries = {
          "list_type": this.activeTab
        }
        this.$router.push({query: queries})
      },

      listStyle(listType) {
        if (this.tabMap[listType]) {
          return this.tabMap[listType].list_style || ''
        }
        return ''
      }
    },

    watch: {
      dataList() {
        this.initTabList()
      }
    },

  }
</script>

<style lang="scss" scoped>

  .content-list {
    /*background: #f2f2f2;*/
    margin-top: 5px;
    min-height: 80vh;

    .content-title {
      padding: 8px 13px;
      border-left: solid 3px blue;
    }
  }

</style>
